module.exports = __webpack_public_path__ + "img/config.2a172e0a.jpg";